import * as RadixPopover from "@radix-ui/react-popover";
import classNames from "classnames";

interface PopoverProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  closeButtonContent?: React.ReactNode;
  onClose?: () => void;
}

export function Popover({
  trigger,
  closeButtonContent,
  children,
  onClose = () => null,
}: PopoverProps) {
  return (
    <RadixPopover.Root
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          className="bg-white p-4 rounded-lg relative shadow-2xl"
          sideOffset={5}
        >
          {children}
          {closeButtonContent && (
            <RadixPopover.Close
              className={classNames(
                "absolute top-4 right-4 rounded-full w-6 h-6 flex items-center justify-center",
                "focus:outline-none focus:ring-2",
              )}
              aria-label="Close"
            >
              {closeButtonContent}
            </RadixPopover.Close>
          )}
          <RadixPopover.Arrow className="fill-white" />
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
